import { parseSettingsWithExt } from "./utils/parse-settings"
import json from "../settings.json"
import { AppSettings } from "~/types"

export const settings = parseSettingsWithExt(json) as AppSettings

export default settings